import { FieldMergeFunction, FieldPolicy } from "@apollo/client";

import { createPHIValue, PHIValue } from "../phi-value";

export const phiStringTypePolicy: FieldPolicy<PHIValue<string>, string> = {
  merge: ((_, incoming) => {
    if (typeof incoming === "string") {
      return createPHIValue(incoming);
    }

    if (typeof incoming === "object") {
      return incoming;
    }

    return null;
  }) as FieldMergeFunction<PHIValue<string>, string>,
};

export const phiNumberTypePolicy: FieldPolicy<
  PHIValue<number>,
  string | number
> = {
  merge: ((_, incoming) => {
    if (typeof incoming === "number") {
      return createPHIValue(incoming);
    }

    if (typeof incoming === "string") {
      const num = Number(incoming);
      if (isNaN(num)) {
        return null;
      }
      return createPHIValue(num);
    }

    return null;
  }) as FieldMergeFunction<PHIValue<number>, string | number>,
};

export const phiBooleanTypePolicy: FieldPolicy<
  PHIValue<boolean>,
  string | boolean
> = {
  merge: ((_, incoming) => {
    if (typeof incoming === "boolean") {
      return createPHIValue(incoming);
    }

    if (typeof incoming === "string") {
      const lowercaseValue = incoming.toLowerCase();
      if (lowercaseValue === "true") {
        return createPHIValue(true);
      } else if (lowercaseValue === "false") {
        return createPHIValue(false);
      }
    }

    return null;
  }) as FieldMergeFunction<PHIValue<boolean>, string | boolean>,
};
